import { setToken } from '@/utils/token'
import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { history, Link, useModel } from '@umijs/max'
import type { MenuProps } from 'antd'
import { createStyles } from 'antd-style'
import React from 'react'
import { flushSync } from 'react-dom'
import HeaderDropdown from '../HeaderDropdown'

export type GlobalHeaderRightProps = {
  menu?: boolean
  children?: React.ReactNode
}

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState')
  const { currentUser } = initialState || {}
  return <span className='anticon'>{currentUser?.nickname || currentUser?.username}</span>
}

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover
      }
    }
  }
})

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    const { search, pathname } = window.location
    const urlParams = new URL(window.location.href).searchParams
    const searchParams = new URLSearchParams({
      redirect: pathname + search
    })
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect')
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/login' && !redirect) {
      history.replace({
        pathname: '/login',
        search: searchParams.toString()
      })
      setToken('')
    }
  }
  const { styles } = useStyles()

  const { initialState, setInitialState } = useModel('@@initialState')

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }))
      })
      loginOut()
      return
    }
    history.push(`/account/${key}`)
  }

  const loading = (
    <span className={styles.action}>
      <Link to='/login'>前往登录</Link>
    </span>
  )

  if (!initialState) {
    return loading
  }

  const { currentUser } = initialState

  if (!currentUser || !currentUser?.username) {
    return loading
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心'
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置'
          },
          {
            type: 'divider' as const
          }
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录'
    }
  ]

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems
      }}
    >
      {children}
    </HeaderDropdown>
  )
}
